const en = {
  login: {
    username: 'Username',
    email: 'Email',
    password: 'Password',
    repeatPassword: 'Repeat password',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signUpDesc: 'Don’t have an account? Sign up',
    errors: {
      common: 'Wrong credentials',
      invalidEmail: 'Must be a valid email',
    },
    blocked: {
      title: 'Too many failed log in attempts',
      description: 'Please contact ShareVino support for further steps or request a password reset link.',
      resetLink: 'Request reset link',
    },
  },
  signUp: {
    name: 'Partner Company Name',
    description: 'Description',
    partnerType: 'Partner Type',
    reservation: 'Reservation Webpage',
    partnerFeatureTags: 'Partner Feature Tags',
    partnerFeatureTagsPlaceholder: 'Press Enter after input',
    cuisinesTooltip:
      'Add feature tags to highlight key aspects of your offerings. These tags will be displayed on your partner card and wine list, helping customers quickly understand what makes your wines unique. Examples include "Organic," "Award-Winning," "Family-Owned," etc. Choose tags that best represent your strengths and specialties.',
    website: 'Webpage',
    country: 'Country',
    region: 'Region/City',
    fullAddress: 'Profile address',
    fullAddressTooltip:
      'Please enter your address in the following recommended format: region/city, country. Alternatively, you may enter your address in a concise manner as you’d like it to appear on your profile. This information will be displayed on your partner card and wine list to help customers locate you easily.',
    logoFormat: 'Logo',
    contactPerson: 'Contact person',
    contactPersonName: 'Full Name',
    contactPersonEmail: 'Email',
    contactPersonPhone: 'Phone',
    phoneTooltip:
      'Please include your country code with a plus sign (+) when adding your phone number. For example, for a US number, enter +1 followed by your phone number.',
    successTitle: 'Thank you for signing up!',
    successDesc:
      'Please check your email to verify your account and set your password. Once completed, you can log in to access your account.',
    agree: 'I agree with ShareVino’s',
    terms: 'ShareVino’s Terms of Use',
    privacy: 'Privacy Policy',
    and: 'and',
  },
  users: {
    pageTitle: 'Users',
    name: 'Name',
    phoneNumber: 'Phone number',
    email: 'Email',
    currentPassword: 'Current password',
    changePassword: 'Change password',
    newPassword: 'New password',
    repeatNewPassword: 'Repeat new password',
    oldPassword: 'Old password',
    active: 'Active',
    inactive: 'Inactive',
    approved: 'Approved',
    notApproved: 'Not approved',
  },
  wineLists: {
    name: 'Menu name',
    menuTitle: 'List name',
    pageTitle: 'Wine list',
    items: 'Add Wines/Spirits',
    itemsPlaceholder: 'Select by wine/spirit or producer',
    serviceProvider: 'Partner',
    pageHeader: 'Wine list',
    menuItemHelper: 'Enter list name',
    noOptions: 'No options',
    loading: 'Loading...',
    deleteConfirmationTitle: 'Are you sure you want to remove this wine list?',
    deleteConfirmationText: 'If deleted, it will not be possible to recover the wine list.',
    publicList: 'Describe Your List',
    itemsDescription:
      'Select wines/spirits by name or producer, arrange them in your preferred order, and assign a table/location.',
    filter: {
      partner: 'Partner',
    },
    qr: {
      redirectUrl: 'Redirect URL',
      customize: 'Customize QR Code',
      dotsStyle: 'Dots Style',
      squaresStyle: 'Squares Style',
      fluidStyle: 'Fluid Style',
      squareCorners: 'Square Corners',
      roundedSquareCorners: 'Rounded Square Corners',
      roundCorners: 'Round Corners',
      changeQrColor: 'Change QR Code Color',
      resetQrColor: 'Reset QR Code Color',
      changeBackgroundColor: 'Change Background Color',
      resetBackgroundColor: 'Reset Background Color',
      deleteLogo: 'Delete Logo',
      generateQrCode: 'Save & Generate QR Code',
      openQrCode: 'Open QR Code',
      digitalListQrCode: 'Digital List QR Code',
      qrStyle: 'QR Code Style',
      cornersStyle: 'Corners Style',
      qrCodeColor: 'QR Code Color',
      backgroundColor: 'Background Color',
      uploadLogo: 'Upload Logo',
      uploadLogoOptional: 'Upload Logo (optional)',
      digitalListLink: 'Digital List Link',
      openLink: 'Open Wine List',
      notLiveChip: 'Not live yet',
      liveHint: 'Share this link or QR code with guests, clients, or event attendees.',
      liveStatus: {
        live: {
          title: 'Your wine list is ready',
          description:
            'You can include your QR code on tasting sheets, menus, event booklets & tables/booths, or printed materials.',
          text: 'Your digital wine list is live and you can share the link or QR code with guests, clients, or event attendees.',
        },
        pendingApproval: {
          title: 'Your wine list is not live yet',
          text: 'You can continue building your wine list and generating your QR code. Your digital wine list will become publicly available once your account is approved.',
          hint: 'This link will become active automatically once your account is approved.',
        },
        noWines: {
          title: 'Your wine list is not live yet',
          text: 'Add at least one wine or spirit to your list to make your digital wine list available to guests.',
          hint: 'Your link and QR code will become active automatically when you add your first wine or spirit.',
        },
      },
      description:
        'Use your QR code to share your digital list instantly with guests, clients, or event attendees. You can include it on tasting sheets, wine menus, event booklets, event tables/booths, or printed materials.',
      wineLabelDescription:
        "To meet legal requirements, ensure text is included near the QR code indicating that it provides information on the wine's nutrition and ingredients. For example, you can add 'Nutrition & Ingredients' above or below the QR code.",
      warning:
        "WARNING: The list of ingredients and nutrition facts must remain consistent with the information known at the production phase, just as they appear on any physical label. They must not be changed during the product's lifetime. Once the product is on the market and the QR code is in use, the wine details included in the QR label shall not be modified.",
    },
    shouldResetWineRating: 'Activate ClearRate',
    shouldResetWineRatingTooltip:
      'Enable ClearRate feature to reset all current ShareVino ratings for this wine list to zero, allowing for fresh perspectives and feedback on wines tailored to your event or selection. This is a one-time action; once activated, the ratings will start anew but still contribute to the total rating. This feature is ideal for wine events, blind-tasting experiences, and wine competitions. Disable to revert to all-time general ratings.',
    showTableOrWineNumberTooltip:
      'Set each wine’s or spirit’s location type (L/W Type) and number (L/W N°) individually, or apply a single value to the entire list using the controls at the top of the columns.',
    winesTooltip:
      'To add wines to your list, first create them in the ‘Wines’ section. You can rearrange the wines by dragging them into your desired order.',
    createLimit: 'To create additional wine lists, please consider upgrading your plan.',
    descriptionPlaceholder: 'Max 350 characters recommended',
    descriptionTooltip:
      'Add a short description of your wine list, highlighting what guests can expect: region, number of wines, or special features.',
    personalization: {
      title: 'Personalize Your List',
      subtitle: 'Unlock custom branding, colors, and more with Pro & Premium plans.',
      customLogo: 'Custom Logo',
      customLogoTooltip: 'Upload a custom logo for this wine list. If not provided, your profile logo will be used.',
      headerBackgroundColor: 'Header Background Color',
      headerBackgroundColorTooltip: 'Choose a solid or gradient color for your list’s header background.',
      headerFontColor: 'Header Font Color',
      headerFontColorTooltip: 'Choose a solid or gradient color for the list name and location text.',
      uploadLogo: 'Click or drag to upload logo',
      uploadBackground: 'Click or drag to upload background image',
      resetHeaderBackgroundColor: 'Reset to ShareVino default color gradient',
      resetHeaderFontColor: 'Reset to ShareVino default color',
    },
    applyToAll: 'Apply to all',
  },
  colorPicker: {
    solid: 'Solid',
    gradient: 'Gradient',
    direction: 'Direction',
    startColor: 'Start Color',
    endColor: 'End Color',
    preview: 'Preview',
    directions: {
      toRight: 'Left to Right',
      toLeft: 'Right to Left',
      toBottom: 'Top to Bottom',
      toTop: 'Bottom to Top',
      toBottomRight: 'Top Left to Bottom Right',
      toBottomLeft: 'Top Right to Bottom Left',
      toTopRight: 'Bottom Left to Top Right',
      toTopLeft: 'Bottom Right to Top Left',
    },
  },
  wineLabels: {
    pageTitle: 'Wine labels',
    pageDescription: 'Create and manage wine labels.',
    allItems: 'All items',
    create: 'New wine label',
    createLimit: 'To create additional wine labels, please consider upgrading your plan.',
    filter: {
      partner: 'Partner',
    },
    qr: {
      dialogTitle: 'Generate QR Code',
      dialogDescription:
        "To meet legal requirements, ensure text is included near the QR code indicating that it provides information on the wine's nutrition and ingredients. For example, you can add 'Nutrition & Ingredients' above or below the QR code.",
      dialogLinkTitle: 'QR Code URL',
      warningMessage: `WARNING: The list of ingredients and nutrition facts must remain consistent with the information known at the
          production phase, just as they appear on any physical label. They must not be changed during the product's
          lifetime. Once the product is on the market and the QR code is in use, the wine details included in the QR
          label shall not be modified.`,
    },
  },
  serviceProvider: {
    name: 'Partner Company Name',
    type: {
      title: 'Partner Type',
      winery: 'Winery',
      restaurant: 'Restaurant',
      importer: 'Importer',
      eventOrganizer: 'Event Organizer',
      other: 'Other',
    },
    description: 'Description',
    reservation: 'Reservation Webpage',
    partnerFeatureTags: 'Partner Feature Tags',
    partnerFeatureTagsPlaceholder: 'Press Enter after input',
    cuisinesTooltip:
      'Add feature tags to highlight key aspects of your offerings. These tags will be displayed on your partner card and wine list, helping customers quickly understand what makes your wines unique. Examples include "Organic," "Award-Winning," "Family-Owned," etc. Choose tags that best represent your strengths and specialties.',
    website: 'Webpage',
    accountStatus: {
      title: 'Account status',
      active: 'Active',
      inactive: 'Inactive',
    },
    country: 'Country',
    region: 'Region/City',
    fullAddress: 'Profile address',
    fullAddressTooltip:
      'Please enter your address in the following recommended format: region/city, country. Alternatively, you may enter your address in a concise manner as you’d like it to appear on your profile. This information will be displayed on your partner card and wine list to help customers locate you easily.',
    priceCurrency: 'Price currency',
    priceCurrencyTooltip:
      'Symbol or code shown next to your wine prices on ShareVino (e.g. €, £, CHF). Up to 4 characters; leave empty to show $.',
    order: 'Order',
    isQrPartner: 'QR partner',
    isLibrary: 'Wine library',
    logoFormat: 'Logo',
    adminSection: 'Administrative Section',
    contactPerson: 'Contact person',
    creationDate: 'Creation date',
    contactPersonName: 'Full Name',
    contactPersonEmail: 'Email',
    contactPersonPhone: 'Phone',
    phoneTooltip:
      'Please include your country code with a plus sign (+) when adding your phone number. For example, for a US number, enter +1 followed by your phone number.',

    pageTitle: 'Partners',
    pageTitleSp: 'Settings',
    approvePartner: 'Are you sure you want to approve the partner(s) ?',
    approveSuccess: 'Partner(s) has been approved.',
    rejectPartner: 'Are you sure you want to reject the partner(s) ?',
    rejectSuccess: 'Partner(s) has been rejected.',
    rejectError: 'Failed to reject partner(s).',
    descriptionTooltip:
      'Provide a brief overview of your establishment. Focus on key details like your history, attractive offerings, specialties, and unique qualities.',
    reservationTooltip:
      'Add a web link to your reservation page. This will direct customers to book a table, visit, or event directly with your establishment.',
    contactLabel: 'Contact & Social Media Links',
  },
  imageCropper: {
    warningToSmallImage: 'Warning: Image too small. Please upload an image at least 244×488 pixels for best quality.',
    warningSoMuchZoom: 'Warning: Zoomed crop resolution is lower than display size; quality may degrade.',
    errorZoomORChangeAcceptRation: 'Adjust the aspect ratio or turn off "Use Crop" to upload the image as-is.',
    errorLooksScreenZoomIn: 'It looks like your browser or font is zoomed in — could you try resetting to 100% zoom?',
    useCrop: 'Use Crop',
    useCropTooltip: 'Enable cropping if the bottle image needs adjustment. Leave it off to upload the image as-is.',
  },
  menuItem: {
    productDetails: 'Wine/Spirit details',
    sku: 'SKU',
    barcode: 'Barcode',
    name: 'Wine/Spirit name',
    serviceProvider: 'Partner',
    lists: 'Lists',
    description: 'Description',
    price: 'Price',
    discountedPrice: 'Discounted price',
    ingredients: 'Ingredients',
    image: 'Image',
    media: 'Media',
    value: 'Value',
    isSuperVino: 'Supervino',
    status: 'Status',
    year: 'Year',
    yearMin: 'Min',
    yearMax: 'Max',
    yearRange: 'Year',
    itemImage: {
      name: 'Item image',
      description: 'Upload your wine/spirit bottle image.',
      additionalDescription:
        'Wines with clean, professional bottle images get more clicks and saves. Make yours stand out.',
      imageDefaultLabel: 'Upload your image',
      message: 'Drop a jpg or png file, max 10MB',
      dropImage: 'Drop your image here or',
      browse: 'browse',
      original: 'Original',
      square: 'Square 250x250',
      landScape: 'Landscape 480x280',
      tooltip:
        'Upload a high-quality wine/spirit bottle image (JPG, PNG, or WEBP, under 5MB). The bottle should be fully visible, cropped edge to edge, with no background. Turn on the "Use Crop" option if the image needs adjustment.',
    },
    filter: {
      name: 'Name',
      partner: 'Partner',
      wineLibrary: 'Library',
      minPrice: 'Min price',
      maxPrice: 'Max price',
    },
    ean8: 'EAN 8',
    ean13: 'EAN 13',
    upcA: 'UPC-A',
    enableBarcode: 'Select service provider to enable barcode',
    language: 'Language',
    changeLanguage: 'Add or remove language',
    defaultLanguage: 'Default -',
    loading: 'Loading...',
    noOptions: 'No options',
    colorTitle: 'Color *',
    red: 'Red',
    white: 'White',
    orange: 'Orange',
    rose: 'Rose',
    sweetnessTitle: 'Sweetness *',
    brutNature: 'Brut Nature',
    extraBrut: 'Extra Brut',
    brut: 'Brut',
    extraDry: 'Extra Dry',
    dry: 'Dry',
    demiSec: 'Demi-Sec',
    doux: 'Doux',
    semiDry: 'Semi-Dry',
    semiSweet: 'Semi-Sweet',
    sweet: 'Sweet',
    styleTitle: 'Style *',
    still: 'Still',
    sparkling: 'Sparkling',
    fortified: 'Fortified',
    dessert: 'Dessert',
    rating: 'Critics Rating & Awards',
    superVino: 'Supervino',
    food: 'Pairing',
    partnerName: 'Partner',
    producer: 'Producer',
    color: 'Color',
    case: 'Case',
    glass: 'Glass',
    firstGlass: '1st Glass',
    twoFiveGlass: '2-5 Glass',
    flight: 'Flight',
    halfBottle: 'Half Bottle',
    carafe: 'Carafe',
    bottle: 'Bottle',
    magnum1_5l: 'Magnum 1.5L',
    magnum3l: 'Magnum 3L',
    bottle3L: 'Bottle 3L',
    halfCase: 'Half Case',
    threeCases: '3 Cases',
    fiveCases: '5 Cases',
    tenCases: '10 Cases',
    twentyPlusCases: '20+ Cases',
    wineSpecs: 'Share Your Story',
    wineSpecsDescription:
      'Wines with tasting & pairing notes get 2x more clicks and saves. Complete your story for maximum engagement.',
    wineSpecTitle: 'Title',
    wineSpecDescription: 'Description',
    wineSpecView: 'Specification',
    wineSpecSection: {
      profileStoryPlaceholder: `Share your story, vintage background, or producer's notes…`,
      tastingNotesPlaceholder: 'Describe aromas, flavors, texture, or how it evolves in the glass…',
      pairingNotesPlaceholder: 'Suggest foods, occasions, or moods that pair beautifully…',
      noDetails: 'No details are added yet.',
      addWineryImage: 'Add Winery Image',
      changeTemplate: 'Change Template',
    },
    templateModal: {
      title: 'Select Template for {section}',
      noTemplates: 'No templates available',
      loading: 'Loading templates...',
    },
    countries: 'Country',
    region: 'Region',
    subRegion: 'Sub-region',
    wineYear: 'Year/Vintage',
    ratingFieldName: 'Rating type',
    cuisines: 'Cuisines',
    wineType: 'Grape/Spirit',
    foodsMaxMessage: 'Add up to {maxFoodsCount} foods.',
    special: 'Special',
    whereToBuy: 'Where to buy',
    pairingTitle: 'Pairing',
    pairing: 'Pairing',
    showTableOrWineNumber: 'Show Location Type & Number',
    setLocation: 'Choose Location Type/Wine Number',
    setNumber: 'Location/Number',
    setAllLocation: 'L/W type',
    setAllNumber: 'L/W №',
    isTableOrWine: 'Table or wine number',
    tableOrWineNumber: 'Table or wine number',
    table: 'Table',
    wine: 'Wine',
    unit: 'Unit',
    useTableOrWineNumberTooltip:
      'Assign a Wine Location (Table, Area, Zone, Hall, etc.) or Wine Number to showcase this wine during events or experiences with a specific identifier. The identifier will apply across all wine lists. If you prefer to assign the same location or number to all wines on the list, use the wine list-specific location/wine number feature within the Wine Lists – Lists section.',
    whereToBuyTooltip: 'Add a web link directing users to the page where your wines can be purchased.',
    wineSpecsTooltip: `Tell the story behind the bottle. Upload a photo of your winery, distillery, or producer. Describe the flavors and recommend food pairings or serving suggestions to help people connect with your product. Bottles with complete details receive more engagement.`,
    superVinoTooltip: `This feature will place a 'Supervino' tag on the wine, distinguishing it from others and highlighting it as a special selection.`,
    lookingForImporter: `Looking for Importer`,
    lookingForImporterTooltip: `This feature allows you to highlight wines open for import opportunities. When on, “Looking for Importer” will appear on the wine profile and in the filters.`,
    lookingForDistributor: `Looking for Distributor`,
    lookingForDistributorTooltip: `This feature allows you to highlight wines open for distribution opportunities. When on, “Looking for Distributor” will appear on the wine profile and in the filters.`,
    tableOrWineNumberOptions: {
      table: 'Table',
      wine: 'Wine',
      area: 'Area',
      booth: 'Booth',
      hall: 'Hall',
      tent: 'Tent',
      zone: 'Zone',
      notSelected: 'Not selected',
    },
  },
  labels: {
    producer: 'Producer',
    fat: 'Fat (g/100ml)',
    saturates: 'Of which saturates (g/100ml)',
    negligibleFat: 'Contains negligible amounts of fat (≤ 0.5 g/100ml)',
    carbohydrates: 'Carbohydrates (g/100ml)',
    sugars: 'Of which sugars (g/100ml)',
    negligibleCarbohydrates: 'Contains negligible amounts of carbohydrates (≤ 0.5 g/100ml)',
    protein: 'Protein (g/100ml)',
    negligibleProtein: 'Contains negligible amounts of protein (≤ 0.5 g/100ml)',
    salt: 'Salt (g/100ml)',
    negligibleSalt: 'Contains negligible amounts of salt (≤ 0.5 g/100ml)',
    percentage: 'Percentage',
    alcoholVolume: 'Alcohol by volume (ABV)',
    wine: {
      name: 'Wine/Product Name',
      year: 'Wine year/Vintage',
      type: 'Grape Variety',
      image: 'Product image',
      style: 'Wine style',
    },
    product: {
      productInfoTitle: 'Product Information',
      type: 'Product type',
      productTypeSparkling: 'Sparkling Wine Type',
      productTypeOther: 'Other Wine Type',
      grapeVariety: 'Grape variety',
    },
    countries: 'Country',
    deAlcoholization: 'De-alcoholization',
    dateOfMinimumDurability: 'Date of minimum durability/Best before',
    protectedGeographicalIndication: 'Protected geographical indication',
    provenanceOption: 'Origin/Indication of Provenance',
    carbohydratesTitle: 'Carbohydrates Content',
    carbohydratesLabel: 'Contains negligible amounts of Carbohydrates (≤ 0.5 g/100ml)',
    fatTitle: 'Fat Content',
    fatLabel: 'Contains negligible amounts of Fat (≤ 0.5 g/100ml)',
    proteinTitle: 'Protein Content',
    proteinLabel: 'Contains negligible amounts of Protein (≤ 0.5 g/100ml)',
    saltTitle: 'Salt Content',
    saltLabel: 'Contains negligible amounts of Salt (≤ 0.0125 g/100ml)',
    sweetness: {
      brutNature: 'Brut Nature',
      extraBrut: 'Extra Brut',
      brut: 'Brut',
      extraDry: 'Extra Dry',
      drySec: 'Dry (Sec)',
      demiSec: 'Demi-Sec',
      doux: 'Doux',
      dry: 'Dry',
      offDry: 'Off Dry',
      mediumDry: 'Medium Dry',
      medium: 'Medium',
      mediumSweet: 'Medium Sweet',
      sweet: 'Sweet',
    },
    style: {
      still: 'Still',
      semiSparkling: 'Semi-Sparkling',
      sparkling: 'Sparkling',
      fortified: 'Fortified',
      dessert: 'Dessert',
    },
    gasesAndPackagingGases: 'Gases & Packaging Gases',
    energy: {
      title: 'Energy Calculation',
      subTitle: 'These values will be saved as the final energy content:',
      useCalculator: 'Use Calculator',
      energyKcalLabel: 'Energy (kcal)',
      energyKJLabel: 'Energy (kJ)',
      modalTitle: 'Energy Calculator',
      modalSubTitle: 'Choose Calculation Method:',
      automaticCalculator: 'Automatic Calculator',
      manualCalculator: 'Manual Calculator',
      organicAcidLabel: 'Organic acid (g/100ml)',
      residualSugarLabel: 'Residual sugar (g/100ml)',
      polyolsLabel: 'Polyols/Glycerin (g/100ml)',
      alcoholLabel: 'Alcohol (Ethanol) (g/100ml)',
      proteinLabel: 'Protein (g/100ml)',
      fatLabel: 'Fat (g/100ml)',
      salatrimsLabel: 'Salatrims (g/100ml)',
      fibreLabel: 'Fibre (g/100ml)',
      calculatedEnergy: 'Calculated Energy',
      useThisValues: 'Use These Values',
    },
    serviceProvider: 'Partner',
    loading: 'Loading...',
    tooltips: {
      producer:
        'Article 46 of Regulation (EU) 2019/33: ‘Producer’ means a natural or legal person or a group of such persons by whom or on whose behalf the processing of the grapes or of the grape musts into wine or the processing of grape must or wine into sparkling wines, aerated sparkling wine, quality sparkling wine or quality aromatic sparkling wines is carried out.',
    },
    ingredients: {
      title: 'Ingredients',
      acidityps: 'Acidity/pH Regulators',
      preservatives: 'Preservatives & Antioxidants',
      stabilizings: 'Stabilizing Agents',
      sweetenings: 'Sweetening & Enrichment substances',
      gases: 'Gases & Packaging Gases',
      liquors: 'Liquors (Sparking Wines Only)',
      others: 'Other practices',
      allergens: 'Allergens',
      tooltips: {
        acidityps:
          'Substances used to maintain or adjust the acidity levels in wine, ensuring the right balance of flavors and stability.',
        preservatives:
          'Ingredients added to protect the wine from spoilage and oxidation, helping to preserve its quality and extend its shelf life.',
        stabilizings:
          "Substances that help maintain the wine's clarity, consistency, and prevent unwanted reactions during storage.",
        gases: '',
        liquors:
          'Tirage liqueur creates the bubbles in sparkling wine, while expedition liqueur adjusts sweetness and flavor. The regulation allows the terms ‘tirage liqueur’ and ‘expedition liqueur’ to be displayed in the list of ingredients alone, and no need to list their actual constituents.',
        others: '',
        sweetenings:
          'Added to adjust the sweetness or enhance the body of the wine. They can include sugar, grape concentrate, or other approved additives that influence the final flavor profile of the wine.',
        allergens:
          'Ingredients that may cause allergic reactions or intolerances in some individuals. Allergens must also be indicated on the package or the label attached thereto.',
      },
    },
  },
  form: {
    save: 'Save',
    saveChanges: 'Save changes',
    errors: {
      required: 'Required',
      email: 'Must be a valid email',
      notValidForm: 'The form is not valid. Please check for errors.',
      invalidPhone: 'Must be a valid phone number',
      invalidRepeatPassword: 'Passwords do not match',
      accountNotApproved: 'Account not approved yet.',
      maximumImageSize: 'The allowed maximum file size should be 5 MB',
      invalidUrl: 'Must be a valid URL starting with https://',
      logoMinSize: 'Logo must be at least 100x100 pixels',
      backgroundMinSize: 'Background image must be at least 800x400 pixels',
    },
    dropBottleImageOrUpload: 'Drag and drop your bottle image here, or click to upload.',
    dropFileOrUpload: 'Drop a file to upload, or click to select it.',
    dropImageHere: 'Drop image here',
    uploading: 'Uploading...',
    logoSizeHint: 'Minimum 100x100px, JPG/PNG',
    backgroundSizeHint: 'Minimum 800x400px, JPG/PNG',
    create: 'Create',
    logIn: 'Log in',
    render: 'Render',
  },
  table: {
    itemSelected: 'selected',
    noResult: 'No results found',
    user: {
      id: 'ID',
      name: 'Name',
      role: 'Role',
      email: 'Email',
      status: 'Status',
      serviceProvider: 'Partner',
      siteAccessStatus: 'Site access',
      invited: 'Invite sent',
      invitationExpired: 'Invitation expired',
      active: 'Active',
      lastActivity: 'Last activity',
      resend: 'Resend',
      user: 'User',
    },
    sp: {
      id: 'ID',
      sortingOrder: 'Order',
      partnerName: 'Name',
      country: 'Country',
      profileAddress: 'Profile address',
      email: 'Email',
      type: 'Type',
      isQrPartner: 'QR partner',
      isLibrary: 'Library',
      status: 'Status',
      approved: 'Approved',
      order: 'Order',
      createdAt: 'CreatedAt',
    },
    wineList: {
      id: 'ID',
      partner: 'Partner',
      name: 'List Name',
      itemsCount: 'Wines/Spirits',
      resetWineRating: 'ClearRate',
      createdDate: 'CreatedAt',
      isDefault: 'Public List',
    },
    wineLabels: {
      id: 'ID',
      partner: 'Partner',
      producer: 'Producer',
      name: 'Wine Name',
      country: 'Country',
      year: 'Year',
      color: 'Color',
      energyKcal: 'E kcal',
      published: 'On Market',
      createdAt: 'CreatedAt',
    },
    wineListWines: {
      name: 'Name',
      producer: 'Producer',
      wineCountry: 'Country',
      region: 'Region',
      year: 'Year',
      color: 'Color',
      style: 'Style',
      sweetness: 'Sweetness',
      isSuperVino: 'SuperV',
      isTableOrWine: 'L/W type',
      tableNumber: 'L/W №',
      createdAt: 'Created',
    },
    wineLover: {
      user: 'User',
      userType: 'Role',
      provider: 'Channel',
      country: 'Country',
      state: 'State',
      lastLoginDate: 'Last Login',
      registrationDate: 'Reg, Date',
      interests: 'Interests',
      registrationType: 'Business',
      receiveMarketingEmails: 'Deals',
      receiveNewsEmails: 'News',
      receiveEventsEmails: 'Events',
      filter: {
        country: 'Country',
        state: 'State',
        registrationDate: 'Reg, Date',
        registrationDateFrom: 'From',
        registrationDateTo: 'To',
        registrationDateRange: 'Reg, Date',
        lastLogin: 'Last Login',
        lastLoginFrom: 'From',
        lastLoginTo: 'To',
        lastLoginRange: 'Last Login',
        channel: {
          title: 'Channel',
          google: 'Google',
          facebook: 'Facebook',
        },
      },
    },
    wineLoversActivities: {
      id: 'User ID',
      userName: 'User Name',
      userEmail: 'User Email',
      userType: 'Role',
      registrationType: 'Business',
      receiveMarketingEmails: 'Deals',
      receiveNewsEmails: 'News',
      receiveEventsEmails: 'Events',
      activityType: 'Activity Type',
      activityDateTime: 'Activity Date/time',
      partnerName: 'Partner',
      producer: 'Producer',
      wineList: 'Wine List',
      wineName: 'Wine',
      vintage: 'Year',
      rating: 'Rating',
      country: 'Country',
      state: 'State',
      interests: {
        discover: 'Discover',
        rate: 'Rate',
        save: 'Save',
        buy: 'Buy',
        offers: 'Deals',
        events: 'Events',
        learn: 'Learn',
        share: 'Share',
      },
      filter: {
        role: {
          title: 'Role',
          wineEnthusiast: 'Wine Enthusiast',
          wineryProfessional: 'Winery Professional',
          sommelierRestaurant: 'Sommelier/Restaurant',
          eventOrganizer: 'Event Organizer',
          importerDistributor: 'Importer/Distributor',
          retailerWineShop: 'Retailer/Wine Shop',
          wineJournalistEducator: 'Wine Journalist/Educator',
          other: 'Other',
        },
        interests: {
          title: 'Interests',
          discover: 'Discover new wines',
          rate: 'Rate & review wines',
          save: 'Save wines to my personal pick list',
          buy: 'Find & buy my favorite wines',
          offers: 'Get special offers & exclusive deals',
          events: 'Attend wine events & tastings',
          learn: 'Learn more about wine',
          share: 'Share wine experiences with friends',
          notSet: 'Not set',
        },
        registrationType: {
          title: 'Business',
          individual: 'Individual',
          business: 'Business (e.g., Winery)',
        },
        activityType: {
          title: 'Activity Type',
          clickedBuy: 'Clicked "Buy"',
          clickedMore: 'Clicked "More"',
          rate: 'Rated',
          bookmark: 'Saved',
          unBookmark: 'Unsaved',
          follow: 'Followed',
          unfollow: 'Unfollowed',
        },
        receiveMarketingEmails: {
          title: 'Deals',
          yes: 'Yes',
          no: 'No',
        },
        receiveNewsEmails: {
          title: 'News',
          yes: 'Yes',
          no: 'No',
        },
        receiveEventsEmails: {
          title: 'Events',
          yes: 'Yes',
          no: 'No',
        },
        rating: {
          title: 'Rating',
          titleMin: 'Min',
          titleMax: 'Max',
          titleRange: 'Rating',
        },
        activityDateTime: {
          title: 'Activity Date/time',
          titleFrom: 'From',
          titleTo: 'To',
          titleRange: 'Activity Date/time',
        },
        partner: 'Partner',
        wineList: 'Wine List',
        wineName: 'Wine',
        vintage: 'Year',
        producer: 'Producer',
        country: 'Country',
        state: 'State',
      },
    },
    tasteimonials: {
      createdAt: 'Date, time',
      note: 'Tasteimonial',
      response: 'My Reply',
      partnerName: 'Partner',
      producer: 'Producer',
      wine: 'Wine',
      vintage: 'Year',
      wineList: 'List',
      wineLover: 'WineLover',
      status: 'Status',
      filter: {
        status: {
          title: 'Status',
          public: 'Public',
          private: 'Private',
        },
        createdAt: 'Date, time',
        createdAtFrom: 'From',
        createdAtTo: 'To',
        createdAtRange: 'Date, time',
        wineLoverName: 'WineLover',
        partnerName: 'Partner',
        producerName: 'Producer',
        wineName: 'Wine',
        wineListName: 'List',
      },
    },
  },
  footer: {
    poweredBy: 'Powered by',
    copyright: '© ShareVino Inc.',
    version: 'V',
  },
  sidebar: {
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Unlock analytics, Unlimited wines and lists, Campaigns, Custom branding, ClearRate, and more.',
    upgradeButton: 'Upgrade',
  },
  actions: {
    cancel: 'Cancel',
    save: 'Save',
    create: 'Create',
    edit: 'Edit',
    copy: 'Copy',
    delete: 'Delete',
    import: 'Import',
    publish: 'Publish',
    discard: 'Discard',
    download: 'Download',
    confirm: 'Confirm',
    clear: 'Clear',
    apply: 'Apply',
    clearSelection: 'Clear selection',
    createItem: 'Create wine',
    none: 'None',
    removeImage: 'Remove image',
    approve: 'Approve',
    reject: 'Reject',
    export: 'Export',
    makePublic: 'Make Public',
    makePrivate: 'Make Private',
    createNewWine: 'Create New Wine',
    importWineList: 'Import Your Wines',
    findWineFromLibrary: 'Search Wine Library',
    addCreateWine: 'Add / Create Wine',
    addToMyWines: 'Add to my wines',
  },
  general: {
    yes: 'Yes',
    no: 'No',
    loading: 'Loading',
    loadingDescription: 'Loading the page...',
  },
  profile: {
    pageTitle: 'Account',
    changeEmail: {
      title: 'Change Email',
      newEmail: 'New Email',
      sendConfirmationCode: 'Send Confirmation Codes',
      confirmEmailChange: 'Confirm Email Change',
      confirmationSent:
        'Confirmation codes have been sent to your old and new email addresses. Please enter them below.',
      oldEmailCode: 'Old Email Code',
      newEmailCode: 'New Email Code',
    },
  },
  dashboard: {
    title: 'Dashboard',
    description: 'Key trends and reports from your business.',
    globalMetrics: 'Global Metrics (All-Time)',
    timeBasedMetrics: 'Filtered Metrics (By Date & Wine List)',
    allWines: 'All Wines',
    allWinesTooltip: 'Total number of wines you’ve created across all wine lists.',
    allFollowers: 'All Followers',
    allFollowersTooltip:
      'Total number of WineLovers across all your lists who follow your profile to stay updated on your wines, events, and deals. For more insights, go to WineLover Activities.',
    totalVisits: 'Total Visits',
    totalVisitsTooltip: 'Total visits to all your wine lists, from all sources (QR codes, direct links, etc.).',
    averageRating: 'Avg Rating',
    averageRatingTooltip: 'Average user rating across all your wines, from both WineLovers and visitors.',
    totalRatings: 'Total Ratings',
    totalRatingsTooltip:
      'Total number of wine ratings submitted by both WineLovers and unregistered visitors across all your wine lists.',
    totalVisitsByMenu: 'Visits',
    totalVisitsByMenuTooltip:
      'Number of visits to the selected wine list within the chosen date range, from all sources.',
    totalViewsByMenu: 'Wine Views',
    totalViewsByMenuTooltip:
      'Number of times wine profiles of the selected wine list were viewed, including clicks on the “More” button or direct visits.',
    averageRatingByMenu: 'Avg Rating',
    averageRatingByMenuTooltip:
      'Average user rating of wines on the selected wine list, during the selected period, from both WineLovers and visitors.',
    totalRatingsByMenu: 'Total Ratings',
    totalRatingsByMenuTooltip:
      'Total number of wine ratings submitted on the selected wine list during the selected time period, by both WineLovers and visitors.',
    wineViewsBySweetness: 'Wine Views by Sweetness',
    wineViewsBySweetnessTooltip: 'Breakdown of users clicked “More” based on wine sweetness.',
    wineViewsByColor: 'Wine Views by Color',
    wineViewsByColorTooltip: 'Breakdown of users clicked “More” based on wine color.',
    wineViewsByStyle: 'Wine Views by Style',
    wineViewsByStyleTooltip: 'Breakdown of users clicked “More” based on the wine style.',
    engagementOverTime: 'Wine Engagement Trends',
    engagementOverTimeTooltip:
      'Track how your wines are being engaged with over time, including wine list visits, wine profile views (clicks on ‘More’), ratings (from WineLovers and guests), saves, and clicks on ‘Buy’. Click on each metric label below to show or hide it on the chart.',
    visitsByRegion: 'Views by Location',
    visitsByRegionTooltip: 'Number of wine views by users segmented by region.',
    viewsByWine: 'Wine Views by Wine',
    viewsByWineTooltip:
      'Number of times each wine’s profile was viewed, including clicks on the “More” button or direct visits to the wine’s detail page.',
    averageRatingByWine: 'Avg Rating by Wine',
    averageRatingByWineTooltip:
      'Average rating (out of 5) for each wine, combining scores from WineLovers and other visitors.',
    clicksByWine: 'Clicks on “Buy” by Wine',
    clicksByWineTooltip: 'Number of clicks on “Buy” button.',

    lineChart: {
      tip: 'Tip:',
      tipMessage: 'Click on each metric label below to show or hide it on the chart.',
      visits: 'Visits',
      views: 'Clicked "More"',
      ratings: 'Ratings',
      saves: 'Saves',
      buys: 'Clicked “Buy”',
    },
  },
  pages: {
    login: 'Login',
    home: 'Home',
    subscriptions: 'Subscriptions',
    sp: 'Partners',
    spSettings: 'Profile',
    users: 'Users',
    portfolioManagement: 'Portfolio Management',
    winesSpirits: 'Wines & Spirits',
    wineLists: 'Wine Lists',
    insights: 'Insights',
    dashboard: 'Dashboard',
    activities: 'Activities',
    tasteimonials: 'Tasteimonials',
    outreach: 'Outreach',
    campaigns: 'Campaigns',
    campaignId: 'ID',
    campaignName: 'Name',
    campaignType: 'Type',
    campaignStatus: 'Status',
    wineLoversUsers: 'WineLovers',
    configuration: 'Configuration',
    profile: 'Account details',
    notFound: 'Page not found',
    usersAndPermissions: 'Users',
    forgotPasswordText: 'Forgot password?',
    settings: 'Settings',
    wineLabels: 'E-Labels',
    labels: 'EU Wine e-Labels',
    createdAt: 'Created',
    sentAt: 'Sent',
    audience: 'Audience',
    targetRecipients: 'Recipients',
    received: 'Received',
    opened: 'Opened',
    clickedCTA: 'Clicked CTA',
    details: 'Details',
    duplicate: 'Duplicate',
    delete: 'Delete',
    createNewCampaign: 'Create New Campaign',
    emailSubject: 'Campaign Email Subject',
    typeEvent: 'Event',
    typeDeal: 'Deal',
    typeNews: 'News',
    campaignMessage: 'Campaign Message',
    saveDraft: 'Save Draft',
    send: 'Send',
    cancel: 'Cancel',
    partnerAudienceFollowers: 'My Followers',
    partnerAudienceRated: 'Rated',
    partnerAudienceSaved: 'Saved',
    recipientsCount: 'Recipients Count',
  },
  campaigns: {
    view: {
      campaigns: 'Campaign Details',
      campaignName: {
        label: 'Campaign Name',
        tooltip:
          'Give your campaign a short, clear name. This won’t be visible to recipients, just for your reference.',
      },
      emailSubject: {
        label: 'Email Subject',
        tooltip:
          'This is the subject line your audience will see in their inbox. Keep it clear and engaging to encourage opens. Avoid all caps or spammy words — short and specific works best!',
      },
      campaignType: {
        label: 'Campaign Type *',
        tooltip:
          'Choose the type of campaign you’re sending —Event, Deal, or News. You can send campaigns only to WineLovers who have opted in to receive this type of campaign.',
      },
      targetWineLoverAudience: {
        label: 'Target WineLover Audience',
        tooltip: 'Define who should receive this campaign based on their interactions, roles, and preferences.',
      },
      campaignReach: {
        label: 'Campaign Reach',
        tooltip: 'Total number of WineLovers matching your selected filters.',
      },
      interaction: {
        label: 'Interaction Type *',
        tooltip:
          'Choose which group of WineLovers to target. “Followers” are those who follow your profile, while “Rated Wines” and “Saved Wines” refer to WineLovers who have rated or saved at least one wine or spirit from your lists.',
      },
      role: {
        label: 'Role',
        tooltip:
          'Roles are self-selected by WineLovers during registration (e.g., Importer, Sommelier, Wine Enthusiast). Use this to tailor your audience.',
      },
      tradeConsumerAudience: {
        label: 'Trade/Consumer Audience',
        tooltip:
          'Selected by WineLovers during sign-up to indicate whether they’re in the wine business or regular consumers. Use this to tailor your audience.',
      },
      locationTimingFilters: {
        label: 'Location & Timing Filters',
        tooltip: 'Target WineLovers based on their country and the date they joined ShareVino.',
      },
      campaignMessageBuilder: {
        label: 'Campaign Message Builder',
        tooltip:
          'Design the message for your campaign using the drag-and-drop builder. Add text, images, buttons, and more to create a compelling email for your audience.',
      },
      footer: {
        discard: 'Discard',
        save: 'Save Draft',
        saveAndSend: 'Save & Send',
        sendCampaign: 'Send Campaign',
      },
    },
    filters: {
      country: {
        title: 'Country',
      },
      partners: {
        title: 'Partners',
      },
      wineLovers: {
        title: 'WineLovers',
      },
      partnerType: {
        winery: 'Winery',
        restaurant: 'Restaurant',
        eventOrganizer: 'Event Organizer',
        hotel: 'Hotel',
        wineBar: 'Wine Bar',
        retailer: 'Retailer',
      },
      partnerAudience: {
        followers: 'Followers',
        rated: 'Rated',
        saved: 'Saved',
      },
    },
    saAudienceAll: 'All',
    saAudiencePartners: 'Partners',
    saAudienceWineLovers: 'WineLovers',
    recipientsCount: 'Recipients Count',
    notApplicable: 'N/A',
    sendConfirmationTitle: 'Are you sure you want to send this campaign?',
    sendConfirmationText:
      'This will email all recipients and mark status as Sent. You will not be able to edit afterwards.',
    createLimit: 'Your current plan doesn’t include access to this feature. Upgrade now to unlock it.',
  },
  notFound: {
    goBack: 'Back',
    title: 'Not found',
    description: 'Either you typed a wrong URL, or you followed a bad link.',
  },
  emptyPage: {
    addOne: 'Do you want to add one?',
    noData: 'No data yet',
    users: 'No users yet',
    menuItems: 'No wines yet',
    menus: 'No wine list yet',
    usersEmpty: 'There are no users in this account. Start by inviting the account holder to join ShareVino.',
    menusEmpty: "You haven't created a wine list yet — start now to showcase your wines.",
    menuItemEmpty:
      "You'll need wines or spirits in your portfolio before creating a list. Go to {link} to add your first wine or spirit. A wine list is a digital page of your portfolio with a scannable QR code.",
    wines: 'Wines & Spirits',
    menuItemsEmpty:
      'Start building your portfolio. Search wines from our library, import an existing list, or create a new wine from scratch.',
    downloadCsv: ' Download example CSV file.',
    menuItemsArchiveEmpty: 'Wine archive is empty.',
    menuItemsTableEmpty: 'No item!  please select item in advance yet!',
    serviceProviderText: 'Partner',
    labelsEmpty: 'No wine labels yet',
    wineLoversEmpty: 'No wineLovers yet',
    wineLoversActivitiesEmpty:
      'No WineLover activity yet. When visitors scan, save, or rate your wines, activities will appear here.',
  },
  actionMsg: {
    success: {
      operationSucceeded: 'Operation successful.',
    },
    error: {
      unknownError: 'Unknown error.',
      imageMaxSize: 'Image max resolution should be {width} × {height}',
      imageMinSize: 'Image min resolution should be {width} × {height}',
      imageMinMaxSize: 'Image resolution should be min: {minWidth} × {minHeight} max: {maxWidth} × {maxHeight}',
    },
  },
  forgotPassword: {
    email: 'Email',
    submit: 'Submit',
    send: 'Send',
    cancel: 'Cancel',
    back: 'Back to sign in',
    title: 'Forgot Password',
    description: 'Enter your email and we’ll send you a link to reset your password',
    success: {
      title: 'Email sent',
      descriptionPart_1: 'Please follow the instructions in the email we sent to ',
      descriptionPart_2: 'in order to regain access to your account.',
    },
    errors: {
      invalidEmail: 'Must be a valid email',
    },
  },
  resetPassword: {
    title: 'Create a new password to access your account',
    expiredToken: 'Your token has expired, please submit your request again.',
  },
  changePassword: {
    title: 'Update your password for security reasons',
  },
  wines: {
    pageTitle: 'Wines',
    libraryBrowseTitle: 'Wine Library',
    libraryBrowseDescriptionPrefix:
      'Browse 200,000+ wines in our Wine Library, add them to your list, and, as needed, request ',
    libraryBrowseAiEnhancementLink: 'AI Enhancement',
    libraryBrowseDescriptionSuffix: '.',
    aiEnhancementInfoModal: {
      title: 'AI Enhancements',
      introPrefix:
        'Bring your wines to life with rich, ready-to-publish content. Choose the level of enhancement — pay per wine. Contact ',
      supportEmail: 'support@sharevino.co',
      introSuffix: '.',
      bottleImageTitle: 'Bottle Image Only - $2 / wine',
      bottleImageDescription: 'High-quality bottle image sourcing, where available.',
      fullProfileTitle: 'Full Wine Profile - $5 / wine',
      fullProfileDescription:
        'Includes bottle image, wine profile and story, tasting notes, food pairing suggestions, and official images, where available.',
      confirmationText: "We'll confirm details and pricing before proceeding.",
    },
    libraryBrowseReturnAboveTitle: 'Return to My Wines & Spirits',
    libraryPickerTitle: 'Wine libraries',
    libraryPickerEmpty: 'No wine libraries are available yet. Ask a global admin to mark a partner as a library.',
    libraryBrowseBanner: 'Viewing wines from library:',
    copyFromLibrarySuccess: '{count} added to your account.',
    createLimit: 'To create additional wines, please consider upgrading your plan.',
    deleteConfirmationTitle: 'Are you sure you want to permanently delete this item?',
    deleteConfirmationText: 'If deleted, it will not be possible to recover the item.',
    copyConfirmationTitle: 'Choose Partner where to copy selected wines',
    copyAutocompleteLabel: 'Choose partner',
    filter: {
      status: 'Status',
    },
    status: {
      published: 'Published',
      draft: 'Draft',
    },
    statusChipTooltip: {
      live: 'Live on platform',
      pending: 'Awaiting approval',
      locked: 'Upgrade to unlock',
      unlisted: 'Add to wine list',
    },
    importModal: {
      errors: {
        text: 'Errors were found during import:',
        subtext: 'Please download the error report to review the issues.',
        button: 'Download error report',
      },
      dropzone: {
        dragActiveText: 'Drop your file here',
        uploadText: 'Drag and drop your file here or',
        browseLinkText: 'click to browse',
        acceptedFormatsText: 'Accepted formats: Excel',
        turnaroundText: 'Typical turnaround: 1-2 business days.',
      },
    },
  },
  filterFields: {
    search: 'Search',
    none: 'None',
    max: 'Max',
    min: 'Min',
    noMatches: 'No matches found',
    unlocked: 'Unlocked',
    locked: 'Locked',
    withOrder: 'With order',
    noOrder: 'No order',
    attached: 'Attached',
    notAttached: 'Not Attached',
    successful: 'Successful',
    pending: 'Pending',
    processing: 'Processing',
    failed: 'Failed',
    canceled: 'Canceled',
    all: 'All',
    withReview: 'With review',
    onlyRatings: 'Only ratings',
    hasAccess: 'Has access',
    noAccess: 'No access',
    draft: 'Draft',
    enabled: 'Enabled',
    disabled: 'Disabled',
    applied: 'Applied',
    notApplied: 'Not applied',
    yes: 'Yes',
    no: 'No',
    imperial: 'Imperial',
    metric: 'Metric',
    left: 'Left',
    right: 'Right',
    enable: 'Enable',
    disable: 'Disable',
  },
  passwordValidation: {
    password: 'Password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    repeatNewPassword: 'Repeat new password',
    save: 'Save',
    passwordsNotMatch: 'Passwords don’t match',
    minCharacter: 'Must be at least {passwordLength} characters long',
    upperAndLowerCaseCharacters: 'Mixed uppercase and lowercase characters',
    specialCharacter: 'At least 1 number and 1 special character',
  },
  usersRoles: {
    superAdmin: 'Global admin',
    partner: 'Partner',
  },

  account: {
    pageTitle: 'Users',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    phoneTooltip:
      'Please include your country code with a plus sign (+) when adding your phone number. For example, for a US number, enter +1 followed by your phone number.',
    password: 'Password',
    changePassword: 'Change password',
    role: 'Role',
    activityStatus: 'Activity status',
    planException: 'Partner Exception Without Subscription',
    timezone: 'Time zone',
  },
  settings: {
    pageTitle: 'Settings',
    searchCountry: 'Search and add countries',
    countries: 'Countries',
    wineTypes: 'Wine types',
    searchWineType: 'Search and add wine types',
    partnerSort: 'Partner sort type',
    ourImpact: 'Our impact',
    wines: 'Wines',
    partners: 'Partners',
    winelovers: 'Winelovers',
    wineEvents: 'Wine events',
    name: 'Name',
    count: 'Count',
    subscriptionsTitle: 'Subscription Bullets',
    searchBullet: 'Search and add bullets',
  },
  subscriptions: {
    pageTitle: 'Subscriptions',
    plansDescription: {
      wineListDescription:
        'Create dynamic digital wine lists for wine experiences to showcase your wines and engage customers.',
      euDescription: 'Create QR-based wine labels that meet EU regulations.',
    },
    choosePlan: 'Choose a Plan That’s Perfect For You.',
    noAccess1: 'Your current plan doesn’t include access to this feature.',
    shortNoAccess1: 'Your plan doesn’t include this feature.',
    upgrade: 'Upgrade',
    shortNoAccess2: 'to access.',
    noAccess2: 'now to unlock it.',
    subscribe: 'Subscribe',
    currentPlan: 'Current plan',
    freeCurrencyDesc: 'free forever',
    everythingIn: 'Everything in {planName}:',
    wineCount: 'Up to {wineCount} wines',
    unlimitedWine: 'Unlimited wines',
    labelCount: 'Up to {labelCount} labels',
    unlimitedLabel: 'Unlimited labels',
    wineListCount: 'Up to {wineListCount} wine list',
    singleWineListCount: '{wineListCount} wine list',
    unlimitedWineList: 'Unlimited wine lists',
    campaignCount: 'Up to {campaignCount} campaigns',
    dashboardAccess: 'Dashboard for data analytics',
    activityAccess: 'WineLover Engagement Filters',
    billedMonthly: 'Billed monthly',
    billedYearly: 'Billed yearly',
    billedDesc: '/ Month',
    billedYearDesc: '/ Year',
    paymentSuccess: 'Your payment succeeded',
    paymentCanceled: 'Your payment was canceled',
    returnPortal: 'Return portal',
    manageBilling: 'Manage billing',
    customerPortal: 'Customer Billing Portal',
    statuses: {
      canceled: `Your current plan will remain active until the end of your billing period. You’ll still enjoy all premium features until then. Afterward, your account will transition to the Start Plan'.`,
      active: `Subscription is active. To see more you can click 'Customer Billing Portal'.`,
      error: `You have a problem with your subscription. Please click the 'Customer Billing Portal' to see the problem.`,
      noSubscription: 'You do not have an active subscription.',
    },
    types: {
      eu: 'EU Wine Label Plans',
      standard: 'Wine List Plans',
    },
    modal: {
      title: 'Subscription Update (Upgrade/Downgrade)',
      description: `After clicking 'Confirm', your subscription changes will take effect immediately. You will be charged or credited according to the pricing of the new plan. Please review your selection carefully before proceeding. All updates are subject to`,
    },
    freePlanModal: {
      title: 'Start Plan Request',
      description: `After clicking 'Confirm', your request to switch to the Start Plan will be sent to the administrator for approval. You will not be subscribed immediately. Once approved, your subscription will be updated, and you will receive a confirmation email. Please review your selection carefully before proceeding. All updates are subject to`,
    },
  },
  wineLovers: {
    pageTitle: 'WineLovers',
    details: {
      name: 'Name',
      email: 'Email',
      provider: 'Channel',
      country: 'Country',
      state: 'State',
      lastLoginDate: 'Last Login',
      registrationDate: 'Reg, Date',
      receiveMarketingEmails: 'Deals',
      receiveNewsEmails: 'News',
      receiveEventsEmails: 'Events',
      userType: 'Role',
      registrationType: 'Business',
      interests: 'Interests',
      id: 'User ID',
    },
  },
  wineLoversActivities: {
    pageTitle: 'WineLovers Activities',
    details: {
      userName: 'User Name',
      userEmail: 'User Email',
      userId: 'User ID',
      channel: 'Channel',
      role: 'Role',
      registrationType: 'Business',
      interests: 'Interests',
      producer: 'Producer',
      vintage: 'Year',
      receiveMarketingEmails: 'Deals',
      receiveNewsEmails: 'News',
      receiveEventsEmails: 'Events',
      activityTimestamp: 'Activity Date/time',
      activityType: 'Activity Type',
      partnerName: 'Partner',
      menuName: 'Wine List',
      wineName: 'Wine',
      rating: 'Rating',
      country: 'Country',
      state: 'State',
    },
  },
  tasteimonials: {
    deleteModal: {
      title: 'Delete Tasteimonials',
      description: 'Are you sure you want to delete this tasteimonial? This action cannot be undone.',
      descriptionPlural: 'Are you sure you want to delete {count} tasteimonials? This action cannot be undone.',
    },
    responseModal: {
      title: 'Reply to Tasteimonial',
      tasteimonial: 'Tasteimonial',
      response: 'Reply',
      responsePlaceholder: 'Enter your reply to this tasteimonial...',
    },
  },
  welcome: {
    pageTitle: 'Welcome to ShareVino',
    subtitle: 'Create, manage, and showcase your wine & spirits portfolio - faster and smarter.',
    stats: {
      visits: 'Visits',
      totalVisitors: 'Total visitors',
      winesAndSpirits: 'Wines & Spirits',
      wineLists: 'Wine Lists',
      wineListImport: 'Wine List Import',
      plan: 'plan',
      exception: 'Exception',
      proUpgrade: 'Pro: up to 100 · Premium: Unlimited',
      proUpgradeLists: 'Pro: up to 5 · Premium: Unlimited',
      viewDetailedAnalytics: 'View detailed analytics in Dashboard',
    },
    quickActions: {
      title: 'Quick actions',
      importWineList: {
        title: 'Import Your Wines',
        description: "Upload your wine list, tech sheets, or catalog — we'll build it for you.",
        new: 'New',
      },
      findOrCreateWine: {
        title: 'Find or Create Wine',
        description: 'Add wines from the library or create new wines from scratch.',
        new: 'New',
      },
      personalizeProfile: {
        title: 'Personalize My Profile',
        description: 'Add your business details and links in the profile section.',
      },
    },
    features: {
      title: 'What You Can Do with ShareVino',
      digitalWineLists: {
        title: 'Digital Wine Lists',
        description: 'Create and share interactive wine lists or digital catalogs.',
        chip: 'Core',
        goTo: 'Go To My Wines',
      },
      euWineLabels: {
        title: 'EU Wine E-Labels',
        description: 'Regulation-ready labels with nutrition, allergens & ingredients.',
        chip: 'Compliance',
        freePlanCode: 'Free Essential Plan Code: FREELABEL25',
        goTo: 'Go To My E-Labels',
      },
    },
    gettingStarted: {
      title: 'Getting Started in 5 Steps',
      steps: {
        personalizeProfile: {
          title: 'Personalize your profile',
          description: 'Add your business details and links in the Profile section.',
        },
        addWines: {
          title: 'Add wines or spirits',
          description: 'Copy from our library, import a list, or create manually.',
        },
        createList: {
          title: 'Create your List',
          description: 'Create engaging digital lists or catalogs and go live.',
        },
        checkAnalytics: {
          title: 'View engagement activity',
          description: 'Track scans, ratings, saves, and clicks.',
        },
        createCampaign: {
          title: 'Create a Campaign',
          description: 'Send news, events, or deals to followers.',
        },
      },
    },
    videoGuides: {
      title: 'Video Guides',
      viewAll: 'View all',
      videos: {
        gettingStarted: {
          title: 'Step-by-Step Getting Started',
          description: 'A complete walkthrough of ShareVino - from setup to live wine lists.',
          duration: '5:58',
          chipText: 'Recommended',
        },
        eventsFestivals: {
          title: 'For Events & Festivals',
          description: 'Build interactive wine catalogs for seamless, engaging event experiences.',
          duration: '1:35',
        },
        wineriesDistilleries: {
          title: 'For Wineries & Distilleries',
          description: 'Elevate your tasting room and showcases with digital tasting sheets.',
          duration: '1:14',
        },
        wineBarsRestaurants: {
          title: 'For Wine Bars & Restaurants',
          description: 'Design interactive wine menus that enhance guest experience and capture valuable insights.',
          duration: '1:28',
        },
        importersDistributors: {
          title: 'For Importers & Distributors',
          description: 'Share your digital portfolio with clients and track engagement.',
          duration: '1:17',
        },
      },
    },
    help: {
      title: 'Need help?',
      emailSupport: {
        title: 'Email Support',
        email: 'support@sharevino.co',
      },
      whatsapp: {
        title: 'WhatsApp',
        phone: '+1 (718) 300-8589',
      },
      bookDemo: {
        title: 'Book a Demo',
        description: 'Schedule a walkthrough',
      },
    },
    import: {
      freeImportIncluded: '1 Free Import Included',
      description: 'First import is free — any file, any format accepted.',
      learnMore: 'Learn more',
    },
    wineImportModal: {
      title: 'Import Your Wines',
      subTitle:
        "Upload your wine list, tech sheets, product catalog, or any file with your wine details — we'll review and import it for you.",
      rightBtnText: 'Submit Import Request',
      leftBtnText: 'Cancel',
      dropzone: {
        dragActiveText: 'Drop your file here',
        uploadText: 'Drag and drop files here, including Excel/Word files with web links, or',
        browseLinkText: 'click to browse.',
        acceptedFormatsText: 'Accepted formats: Excel, CSV, PDF, JPG, Word, and more.',
        turnaroundText: 'Typical turnaround: 1-2 business days.',
      },
      infoBox: {
        title: 'Your first import is FREE!',
        text: 'Additional imports are $49 per list.',
      },
      template: {
        title: 'Download Import Template (Optional)',
        buttonText: 'Download',
        recommendationTitle: 'For the smoothest and fastest import, we recommend including:',
        columns: {
          wineName: 'Wine Name',
          producer: 'Producer',
          variety: 'Variety',
          vintage: 'Vintage',
          country: 'Country',
          region: 'Region',
          color: 'Color',
          sweetness: 'Sweetness',
          style: 'Style',
        },
        helperText: 'Missing something? No problem - our team will complete any gaps for you.',
      },
      selectedFiles: {
        totalSize: 'Total size: {{size}}',
        buttons: {
          clear: 'Clear',
          remove: 'Remove',
        },
      },
      aiEnhancements: {
        title: 'AI Enhancements',
        optionalLabel: '(Optional)',
        description: 'Want us to enrich your wines with images and professional descriptions?',
        options: {
          none: {
            title: 'No enhancement',
            description: 'Import as-is from your file, with default or your own bottle images.',
          },
          imageOnly: {
            title: 'Bottle Image Only - $2 / wine',
            description: 'High-quality bottle image sourcing, where available.',
          },
          fullProfile: {
            title: 'Full Wine Profile - $5 / wine',
            description:
              'Includes bottle image, wine profile and story, tasting notes, food pairing suggestions, and official images, where available.',
          },
        },
        confirmationText: "We'll confirm details and pricing before proceeding.",
      },
      notes: {
        title: 'Notes for our team',
        optionalLabel: '(optional)',
        placeholder: 'Specify wines for AI enhancement or add instructions.',
      },
      postSubmission: {
        title: 'Import request received',
        firstTextLine: 'Thank you for uploading your wine list.',
        secondTextLine:
          'Our team will review your file and complete the import within 2 business days. Your wines will appear in your Wines & Spirits section once ready.',
        thirdTextLine: 'We’ve sent a confirmation to your email.',
        buttonText: 'Done',
      },
    },
  },
};

export { en };
